import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyD0J69up6p56WabNUV039vGs13zMzGtKAo",
  authDomain: "tint0-erp.firebaseapp.com",
  projectId: "tint0-erp",
  storageBucket: "tint0-erp.firebasestorage.app",
  messagingSenderId: "892805233132",
  appId: "1:892805233132:web:bebf17fd101516b3e1e8c9",
  measurementId: "G-7QJH6HDG91"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
